import AdTokenMessages from "@/shared/adTokens/AdTokenMessages";
import { useAdTokenCheck, type AdTokenEdit } from "@/shared/adTokens/useAdTokenCheck";

/**
 * One ad copy field's token notes, beside its title (MPN-1930). The check and the messages
 * are shared (src/shared/adTokens); this is only where they meet the copy form.
 */
export default function AdCopyTokenNotes({ value, onFix }: {
    value: string;
    /**
     * Apply a fix to the field as an edit. Handed a function of the field's current text,
     * since the note may be a pause behind what is in the field now.
     */
    onFix: (change: (current: string) => AdTokenEdit | null) => void;
}) {
    const check = useAdTokenCheck(value);
    return (
        <AdTokenMessages
            notes={check.notes}
            noteStyle={{ marginLeft: 6 }}
            onUseCanonical={(note) => onFix((current) => check.applyAliasFix(note, current))}
        />
    );
}
